import { useState } from 'react'
import type { TIconProps } from '~/components/icon'
import { CHECKBOX_STATE_MAPPER, type TCheckboxSizes } from '../types'

export const useCheckboxVariants = () => {
  const [pressed, setPressed] = useState(false)

  const iconSizeMapping: Record<TCheckboxSizes, TIconProps['size']> = {
    md: 'tiny',
    ml: 'small',
    lg: 'medium',
    xl: 'medium',
  }

  const renderCurrentStateCheckbox = (
    indeterminate: boolean,
    isChecked: boolean
  ) => {
    if (indeterminate) {
      return CHECKBOX_STATE_MAPPER.INDETERMINATE
    }
    if (isChecked) {
      return CHECKBOX_STATE_MAPPER.CHECKED
    }
    return CHECKBOX_STATE_MAPPER.UNCHECKED
  }

  return {
    renderCurrentStateCheckbox,
    iconSizeMapping,
    pressed,
    setPressed,
  }
}
